import React, { useState, useEffect } from "react";
import "./buyShangu.css";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import buyShangu from "../../images/buy-shangu.svg";
import Web3 from "web3";

import { contractAbi } from "../../contractAbi";
import { LoadingModal, MessageModal } from "../Modal/Modal";

import AA from "../../images/shangu_updated/AA.jpg";

const BuyShangu = (props) => {
    const [counter, setCounter] = useState(1);
    const [open, setOpen] = React.useState(false);
    const [openMessage, setOpenMessage] = useState(false);
    const [messageData, setMessageData] = useState("Some Error Occurred...");

    const [whitelistedUser, setWhitelistedUser] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const showMessage = () => setOpenMessage(true);
    const closeMessage = () => setOpenMessage(false);

    const web3 = new Web3(Web3.givenProvider);

    const getMint = async () => {
        if(!props.metaAddress) {
            return;
        }
        handleOpen();
        const tokenUri =
            "https://unicus.mypinata.cloud/ipfs/QmSBSLVU3F1rdHGZ34Wvxs7qG6KkFuf3vYFifTfBihsadU";

        try {
            const address = await web3.eth.getAccounts();
            const contract = new web3.eth.Contract(
                contractAbi,
                "0x933509fe5bde7af962f34cca971f5ec3037f0bc6"
            );
            const priceValue = web3.utils.toWei((0.1 * counter).toString());
            const result = await contract.methods
                .awakeningMint(counter)
                .send({ from: address[0], value: priceValue });
            // console.log(result)
            handleClose();
            // show message
            showMessage();
            if (result.blockHash.length > 0) {
                setMessageData("Your transaction was successful");
            }
        } catch (err) {
            // console.log(err)
            handleClose();
            showMessage();
            setMessageData("Some error occurred while paying...");
        }
    };

    useEffect(async () => {
        console.log(props.metaAddress);
        if (props.metaAddress) {
            const contract = new web3.eth.Contract(
                contractAbi,
                "0x933509fe5bde7af962f34cca971f5ec3037f0bc6"
            );
            var isWhitelisted = await contract.methods
                .whitelistOneMint(props.metaAddress)
                .call();
            // console.log("whitelisetd ",isWhitelisted);
            setWhitelistedUser(isWhitelisted);
        }
    }, [props.metaAddress]);

    useEffect(() => {
        console.log("whiteliset ", whitelistedUser);
    }, [whitelistedUser]);
    return (
        <>
            <LoadingModal
                handleOpen={handleOpen}
                handleClose={handleClose}
                setOpen={setOpen}
                open={open}
            />

            <MessageModal
                message={messageData}
                handleOpen={showMessage}
                handleClose={closeMessage}
                setOpen={setOpenMessage}
                open={openMessage}
            />
            <div className="buy-shangu" id="buyShangu">
                <div className="buy-shangu-slider">
                    <img className="shangu-image" src={AA} alt="buy shangu" />
                    <div>Limited Time only</div>
                </div>

                <div className="buy-shangu-info">
                    <div className="buy-shangu-info-1">
                        <h2>
                            Mint a <span>Legend of Shangu</span>
                        </h2>
                        <h3>Select how many Legends you want to mint</h3>
                    </div>

                    <div className="buy-shangu-info-2">
                        <h4>Whitelist 1</h4>
                        <h3>
                            Price Per Legend <span>0.1 ETH</span>
                        </h3>
                    </div>

                    <div className="buy-shangu-info-3">
                        <div>
                            <h2>
                                Quantity{" "}
                                <span className="cap-qty">(Max 12)</span>
                            </h2>
                            {/* <h3>10</h3> */}
                            <ButtonGroup
                                size="small"
                                aria-label="small button group"
                            >
                                {
                                    <Button
                                        className="counter-minus"
                                        disabled={counter <= 0}
                                        onClick={() => {
                                            setCounter(counter - 1);
                                        }}
                                    >
                                        -
                                    </Button>
                                }

                                {
                                    <Button className="counter-text" disabled>
                                        {counter}
                                    </Button>
                                }

                                <Button
                                    className="counter"
                                    onClick={() => {
                                        setCounter(counter + 1);
                                    }}
                                    disabled={counter >= 12}
                                >
                                    +
                                </Button>
                            </ButtonGroup>
                        </div>
                        <div>
                            <h2>Total</h2>
                            <h3>{(counter * 0.1).toFixed(2)} ETH</h3>
                        </div>
                    </div>
                    {/* if not login show mint now */}
                    {(!props.metaAddress) && (
                        <div className="buy-shangu-now" onClick={props.connectWallet}>
                            Connect Wallet 
                        </div>
                    )}

                    {/* if login then check for whitelisted */}
                    {(whitelistedUser && props.metaAddress) && (
                        <div className="buy-shangu-now" onClick={getMint}>
                            Mint Now
                        </div>
                    )}
                    {(!whitelistedUser && props.metaAddress) && (
                        <div className="buy-shangu-now buy-shangu-disable">
                            Address not whitelisted
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default BuyShangu;
